import { Button } from '@/components/ui/button';

interface FooterEditLinkProps {
  href: string;
  label: string;
}

export function FooterEditLink({ href, label }: FooterEditLinkProps) {
  return (
    <Button asChild variant="outline-subtle">
      <a href={href}>{label}</a>
    </Button>
  );
}
